const userReviewPageClasses = {
  container:
    'flex flex-col gap-12 px-8 mb-32 sm:px-16 md:px-32 lg:px-64 mt-16 sm:mt-24 md:mt-32 lg:mt-48 items-center text-lg ',
  reviewsContainer: 'flex flex-col items-center',
  reviewListContainer:
    'flex flex-col-reverse items-center w-full text-slate-400',
}

export default userReviewPageClasses
